import ReactPlayer from "react-player";
import React from "react";
import NotificationSystem from "react-notification-system";
import {
  Card,
  CardBody,
  CardHeader,
  CardImg,
  Col,
  Row,
  Button,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  CardFooter,
} from "reactstrap";
import {
  MdDeleteForever,
  MdKeyboardArrowLeft,
  MdKeyboardArrowRight,
} from "react-icons/md";
import { IoMdEye, IoMdEyeOff } from "react-icons/io";

import Page from "../components/Page";
import PageSpinner from "../components/PageSpinner";

import { NOTIFICATION_SYSTEM_STYLE } from "../utils/constants";

import * as Server from "../Server";
import config from "./../config/local";

let selectedfeedId = null;

class DuaFeeds extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      pages: 0,
      limit: 10,
      feeds: [],
      appName: "trandz",
      totalFeeds: 0,
      pageNumbers: [],
      showLoader: false,
      removeFeedConfirmationModal: false,
    };
  }

  componentDidMount() {
    this.getFeeds();
  }

  getFeeds = async (event) => {
    try {
      this.setState({ showLoader: true });
      let page = this.state.page;
      let pageLimit = this.state.limit;
      let response = await Server.serverRequest({
        url: "web/allFeeds",
        method: "POST",
        data: { page, pageLimit, appName: this.state.appName, postType: "dua" },
      });
      if (response) {
        this.setState({
          showLoader: false,
          pages: response.pages,
          feeds: response.feeds,
          totalFeeds: response.totalFeeds,
        });
        let pageNumbers = [];
        for (let page = 1; page <= response.pages; page++) {
          pageNumbers.push(page);
        }
        this.setState({ pageNumbers: pageNumbers });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  removeFeed = async () => {
    try {
      this.setState({ showLoader: true });
      let response = await Server.serverRequest({
        url: `/web/deletePost?postId=${selectedfeedId}`,
        method: "DELETE",
      });
      if (response) {
        this.setState({ showLoader: false });
        this.notificationSystem.addNotification({
          message: response.message,
          level: "error",
        });
        this.getFeeds();
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  toggleremoveFeedConfirmationModal = async (id) => {
    if (id) selectedfeedId = id;
    this.setState({
      removeFeedConfirmationModal: !this.state.removeFeedConfirmationModal,
    });
  };

  refreshPagination = async (page, limit) => {
    this.setState({ page: parseInt(page, 10), limit: limit }, () => {
      this.getFeeds();
    });
  };

  hideUnhideFeed = async (obj) => {
    try {
      this.setState({ showLoader: true });
      let response = await Server.serverRequest({
        url: "web/hideUnhideFeed",
        method: "POST",
        data: obj,
      });
      if (response) {
        this.setState({ showLoader: false });
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
        this.getFeeds();
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  render() {
    return (
      <div>
        <PageSpinner showLoader={this.state.showLoader} />
        <Page title="Feeds" breadcrumbs={[{ name: "Feeds", active: true }]}>
          <Row>
            <Col>
              <Card className="mb-3">
                <CardHeader>
                  <Row>
                    <Col xl={4} lg={12} md={12}>
                      <div className="d-flex">
                        <div sm={4} className="mt-2 pr-2">
                          <Label>Shown</Label>
                        </div>
                        <div sm={4}>
                          <Input
                            type="select"
                            name="pageLimit"
                            onChange={(event) => {
                              this.refreshPagination(1, event.target.value);
                            }}
                          >
                            <option value={10}>10</option>
                            <option value={20}>20</option>
                            <option value={30}>30</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                          </Input>
                        </div>
                        <div sm={4} className="mt-2 pl-2">
                          <Label>entries</Label>
                        </div>
                      </div>
                    </Col>
                    <Col xl={4} lg={12} md={12}>
                      <div className="d-flex justify-content-center">
                        <div className="mt-2 pr-2">
                          <Label>
                            Showing{" "}
                            {!this.state.totalFeeds
                              ? 0
                              : this.state.page * this.state.limit -
                                (this.state.limit - 1)}{" "}
                            to{" "}
                            {this.state.page * this.state.limit >
                            this.state.totalFeeds
                              ? this.state.totalFeeds
                              : this.state.page * this.state.limit}{" "}
                            of {this.state.totalFeeds}
                          </Label>
                        </div>
                      </div>
                    </Col>
                    <Col xl={4} lg={12} md={12}>
                      <div className="d-flex justify-content-end">
                        <div sm={4} className="pr-2">
                          <Button
                            className="rounded-circle"
                            disabled={this.state.page <= 1}
                            onClick={(event) =>
                              this.refreshPagination(
                                this.state.page - 1,
                                this.state.limit
                              )
                            }
                          >
                            <MdKeyboardArrowLeft size="20px"></MdKeyboardArrowLeft>
                          </Button>
                        </div>
                        <div sm={4}>
                          <Input
                            type="select"
                            value={this.state.page}
                            name="filter"
                            onChange={(event) => {
                              this.refreshPagination(
                                event.target.value,
                                this.state.limit
                              );
                            }}
                          >
                            {this.state.pageNumbers.length ? (
                              this.state.pageNumbers.map(
                                (pageNumber, index) => (
                                  <option value={pageNumber} key={index}>
                                    {pageNumber}
                                  </option>
                                )
                              )
                            ) : (
                              <option value={0}>0</option>
                            )}
                          </Input>
                        </div>
                        <div sm={4} className="pl-2">
                          <Button
                            className="rounded-circle"
                            disabled={this.state.page >= this.state.pages}
                            onClick={(event) =>
                              this.refreshPagination(
                                this.state.page + 1,
                                this.state.limit
                              )
                            }
                          >
                            <MdKeyboardArrowRight size="20px"></MdKeyboardArrowRight>
                          </Button>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody>
                  <Row>
                    {this.state.feeds && this.state.feeds.length ? (
                      <>
                        {this.state.feeds.map((feed, index) => (
                          <Col
                            xl={3}
                            lg={3}
                            md={3}
                            key={index}
                            style={{ height: "270px" }}
                            className="my-2"
                          >
                            <Card style={{ height: "inherit" }}>
                              <CardBody style={{ overflowY: "auto" }}>
                                {feed.url ? (
                                  <CardImg key={index} src={feed.url} alt="" />
                                ) : (
                                  <ReactPlayer
                                    width="100%"
                                    height="100%"
                                    controls={true}
                                    url={`${config.videoBaseUrl}/${feed.name}.mp4`}
                                  />
                                )}
                              </CardBody>
                              <CardFooter>
                                {feed.isVisible ? (
                                  <Button
                                    onClick={() =>
                                      this.hideUnhideFeed({
                                        postId: feed.postId,
                                        isVisible: false,
                                      })
                                    }
                                  >
                                    <IoMdEye />
                                  </Button>
                                ) : (
                                  <Button
                                    onClick={() =>
                                      this.hideUnhideFeed({
                                        postId: feed.postId,
                                        isVisible: true,
                                      })
                                    }
                                  >
                                    <IoMdEyeOff />
                                  </Button>
                                )}
                                <Button
                                  style={{ marginLeft: "10px" }}
                                  onClick={(event) =>
                                    this.toggleremoveFeedConfirmationModal(
                                      feed.postId
                                    )
                                  }
                                >
                                  <MdDeleteForever />
                                </Button>
                              </CardFooter>
                            </Card>
                          </Col>
                        ))}
                      </>
                    ) : (
                      <Col
                        xl={12}
                        lg={12}
                        md={12}
                        style={{
                          textAlign: "center",
                          backgroundColor: "#e9ecef",
                        }}
                      >
                        <h2 style={{ margin: "10px" }}>No Feeds</h2>
                      </Col>
                    )}
                  </Row>
                </CardBody>
                {this.state.removeFeedConfirmationModal ? (
                  <Modal
                    isOpen={this.state.removeFeedConfirmationModal}
                    toggle={(event) => this.toggleremoveFeedConfirmationModal()}
                    className="modal-md"
                  >
                    <ModalHeader
                      toggle={(event) =>
                        this.toggleremoveFeedConfirmationModal()
                      }
                    ></ModalHeader>
                    <ModalBody>
                      Are you sure you want to delete this feed ?
                    </ModalBody>
                    <ModalFooter>
                      <Button
                        color="secondary"
                        onClick={(event) =>
                          this.toggleremoveFeedConfirmationModal()
                        }
                      >
                        Cancel
                      </Button>{" "}
                      <Button
                        color="primary"
                        onClick={(event) => {
                          this.toggleremoveFeedConfirmationModal();
                          this.removeFeed();
                        }}
                      >
                        Delete
                      </Button>
                    </ModalFooter>
                  </Modal>
                ) : null}
              </Card>
            </Col>
          </Row>
          <NotificationSystem
            dismissible={false}
            ref={(notificationSystem) =>
              (this.notificationSystem = notificationSystem)
            }
            style={NOTIFICATION_SYSTEM_STYLE}
          />
        </Page>
      </div>
    );
  }
}
export default DuaFeeds;
